import { Validators } from '@angular/forms';
import { IGenCatForm, NgGenCatInputTextComponent } from '@ctti-dev/ng-gencat';
import { Callout } from '@shared/models/callout.model';
import { passwordValidator } from '@shared/utils/validators.utils';

export const REQUEST_PASSWORD_RESET_FORM_CONFIG: IGenCatForm = {
  newPassword: {
    component: NgGenCatInputTextComponent,
    customClass: 'col-12',
    label: 'resetPassword.form.newPassword',
    size: 'small',
    optionalLabel: false,
    typeInput: 'password',
    placeholder: 'Escriu la nova contrasenya',
    validators: [
      Validators.required,
      Validators.minLength(8),
      passwordValidator(8),
    ],
  },
  confirmNewPassword: {
    component: NgGenCatInputTextComponent,
    customClass: 'col-12',
    label: 'resetPassword.form.confirmNewPassword',
    size: 'small',
    optionalLabel: false,
    typeInput: 'password',
    placeholder: 'Escriu de nou la nova contrasenya',
    validators: [
      Validators.required,
      Validators.minLength(8),
      passwordValidator(8),
    ],
  },
};

export const RESET_PASSWORD_INFO_CALLOUT: Partial<Callout> = {
  calloutRender: true,
  type: 'informative',
  dismissible: false,
  message: 'resetPassword.callout.info.text',
};

export const RESET_PASSWORD_ERROR_CALLOUT: Partial<Callout> = {
  calloutRender: true,
  type: 'error',
  dismissible: true,
  message: 'resetPassword.callout.error.text',
  title: 'resetPassword.callout.error.title',
};
